import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './index';

export const reducers = {
  getShoppingCart(state) {
    state.isLoading = true;
  },
  getShoppingCartError(state, action: PayloadAction<any>) {
    state.data = initialState.data;
    state.error = action.payload;
    state.isLoading = false;
  },
  getShoppingCartSuccess(state, action: PayloadAction<number>) {
    state.data = action.payload;
    state.error = null;
    state.isLoading = false;
  },
};
